import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-206" data-mp="1jhk9yn6s8agq">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-207" data-mp="1teg9i3epdm95" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-black text-teal-400" data-id="element-208" data-mp="1tddmi6ki43yi">:</span>}
          <span className="flex min-w-[68px] flex-col items-center rounded-xl bg-orange-500 px-3 py-2.5 leading-none shadow-md shadow-black/40" data-id="element-209" data-mp="38unrexp5c7gd">
            <b className="text-3xl font-bold tabular-nums tracking-tight text-zinc-950" data-id="element-210" data-mp="34t24skmt8esz">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-bold uppercase tracking-wider text-zinc-950" data-id="element-211" data-mp="2h68kodgut0r1">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}